<template>
  <div class="quiz-target">
    <div class="quiz-target__title">Цель кредита</div>
    <div class="quiz-target__block" v-for="value in filteredValues" :key="value.id">
      <div class="quiz-target__block-title">
        <span>{{ value.title }}</span>
      </div>
      <div class="quiz-target__block-list">
        <button 
          v-for="item in value.items" 
          :key="item.id" 
          class="quiz-target__block-item"
          @click="$emit('input', item.id)"
        >
          {{ item.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

const HARDCODED_VALUES = [
  {
    id: 0,
    title: 'Ипотека',
    items: [
      { id: 1181, name: "Готовая недвижимость" },
      { id: 1218, name: "Строящаяся недвижимость" },
    ]
  },
  {
    id: 1,
    title: 'Потребительское кредитование',
    items: [
      { id: 2514, name: "Потребительский кредит" },
      { id: 2515, name: "Кредитная карта" }
    ]
  },
  {
    id: 2,
    title: 'Кредитование автомобилей',
    items: [
      { id: 2801, name: "Автокредит" },
      { id: 2896, name: "Кредит под залог авто" },
    ]
  },
]

export default Vue.extend({
  name: 'QuizRadio',

  props: {
    input: {
      type: Array
    }
  },

  data() {
    return {
      values: HARDCODED_VALUES,
    };
  },

  computed: {
    filteredValues() {
      const other = {
        id: this.values.length + 1,
        title: 'Иное',
        items: []
      };

      const filteredValues = this.values.map(value => {
        const filteredItems = value.items.filter(item => this.input?.some(value => value.id === item.id));
        return { ...value, items: filteredItems };
      });

      if (this.input) {
        this.input.forEach(inputValue => {
          const existsInValues = this.values.some(value => 
            value.items.some(item => item.id === inputValue.id)
          );
          
          if (!existsInValues) {
            other.items.push({ id: inputValue.id, name: inputValue.name });
          }
        });
      }
      
      if (other.items.length > 0) {
        return [...filteredValues, other];
      }

      return filteredValues;
    }
  }
});
</script>

<style lang="scss" scoped>
.quiz-target {

  padding: 24px 28px 0;


  &__title {
    font-weight: 500;
    font-size: 16px;
    color: #A01919;
    margin-bottom: 20px;
  }

  &__block-title {
    position: relative;
    padding: 0 32px;
    height: 24px;

    & span {
      padding: 0 8px;
      font-size: 14px;
      color: #9D9D9D;
      background-color: #fff;
    }

    &::before {
      z-index: -1;
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      height: 1px;
      background-color: #D9D9D9;
    }
  }

  &__block-list {
    margin: 12px 0;
    padding: 0 8px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    align-content: center;
  }
  
  &__block-item {
    position: relative;
    height: 24px;
    margin: 0 !important;
    padding-left: 32px;
    color: rgba(0, 0, 0, 0.6);
    border: none;
    background: none;
    font-size: 16px;
    text-align: left;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 2px;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 24px;
      border: 2px solid rgba(0, 0, 0, 0.6);

    }
  }
}

@container bank-card (max-width: 799px) {
  .quiz-target__block-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@container bank-card (max-width: 600px) {
  .quiz-target {
    &__block-list {
      grid-template-columns: repeat(1, 1fr);
    }

    &__block-item {
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
} 
</style>
